"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createBreakpoints = void 0;
var createBreakpoints_1 = __importDefault(require("@material-ui/core/styles/createBreakpoints"));
var defaultValues = {
    xs: 0,
    sm: 768,
    md: 1024,
    lg: 1280,
    xl: 1440,
    xxl: 1920,
};
var createBreakpoints = function (_a) {
    if (_a === void 0) { _a = {}; }
    var _b = _a.values, values = _b === void 0 ? defaultValues : _b, _c = _a.keys, keys = _c === void 0 ? Object.keys(defaultValues) : _c, options = __rest(_a, ["values", "keys"]);
    return (0, createBreakpoints_1.default)(__assign(__assign({}, options), { values: values, keys: keys }));
};
exports.createBreakpoints = createBreakpoints;
//# sourceMappingURL=createBreakpoints.js.map